import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const attio = defineConnector({
  identifier: "attio",
  name: "Attio",
  tagLine: "Collaborative CRM",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.attio\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create an Attio app",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Attio API key docs](https://docs.attio.com/rest-api/how-to-get-your-api-key) and create an OAuth app or API key from your Attio workspace developer settings. Copy the client ID and client secret from the app you create.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/attio/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Attio account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Attio account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://app.attio.com/authorize",
    tokenEndpoint: () => "https://app.attio.com/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: { protocol: "http", request: () => "https://api.attio.com/" },
});
